export const BANKS_FETCH_INIT = 'BANKS_FETCH_INIT';
export const BANKS_FETCH_SUCCESS = 'BANKS_FETCH_SUCCESS';
export const BANKS_FETCH_ERROR = 'BANKS_FETCH_ERROR';

export const BANKS_POST_INIT = 'BANKS_POST_INIT';
export const BANKS_POST_SUCCESS = 'BANKS_POST_SUCCESS';
export const BANKS_POST_ERROR = 'BANKS_POST_ERROR';

export const BANKS_RESET = 'BANKS_RESET';
